import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from "react";
import { ErrorMessage } from "@components/atoms";
import { CreditCardForm } from "@components/organisms";
import { braintreePayment } from "../../../../core/payments/braintree";
import { maybe, removeEmptySpaces } from "../../../../core/utils";
import * as S from "./styles";
var INITIAL_CARD_ERROR_STATE = {
  fieldErrors: {
    cvv: null,
    expirationMonth: null,
    expirationYear: null,
    number: null
  },
  nonFieldError: ""
};

var BraintreePaymentGateway = function BraintreePaymentGateway(_ref) {
  var _config$find;

  var config = _ref.config,
      processPayment = _ref.processPayment,
      formRef = _ref.formRef,
      formId = _ref.formId,
      _ref$errors = _ref.errors,
      errors = _ref$errors === void 0 ? [] : _ref$errors,
      postalCode = _ref.postalCode,
      onError = _ref.onError;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      submitErrors = _useState2[0],
      setSubmitErrors = _useState2[1];

  var clientToken = (_config$find = config.find(function (_ref2) {
    var field = _ref2.field;
    return field === "client_token";
  })) === null || _config$find === void 0 ? void 0 : _config$find.value;

  var _React$useState = React.useState(INITIAL_CARD_ERROR_STATE),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      cardErrors = _React$useState2[0],
      setCardErrors = _React$useState2[1];

  var setCardErrorsHelper = function setCardErrorsHelper(errors) {
    return errors.map(function (_ref3) {
      var field = _ref3.field,
          message = _ref3.message;
      return setCardErrors(function (_ref4) {
        var fieldErrors = _ref4.fieldErrors;
        return {
          fieldErrors: _objectSpread({}, fieldErrors, _defineProperty({}, field, {
            field: field,
            message: message
          }))
        };
      });
    });
  };

  var tokenizeCcCard = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(creditCard) {
      var cardData, braintreeTokenErrors;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setCardErrors(INITIAL_CARD_ERROR_STATE);
              _context.prev = 1;

              if (!clientToken) {
                _context.next = 7;
                break;
              }

              _context.next = 5;
              return braintreePayment(clientToken, creditCard);

            case 5:
              cardData = _context.sent;
              return _context.abrupt("return", cardData);

            case 7:
              braintreeTokenErrors = [{
                message: "Braintree gateway misconfigured. Client token not provided."
              }];
              setSubmitErrors(braintreeTokenErrors);
              onError(braintreeTokenErrors);
              _context.next = 17;
              break;

            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](1);
              setCardErrorsHelper(_context.t0);
              onError(_context.t0);
              return _context.abrupt("return", null);

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 12]]);
    }));

    return function tokenizeCcCard(_x) {
      return _ref5.apply(this, arguments);
    };
  }();

  var handleSubmit = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(formData) {
      var creditCard, payment, braintreePayloadErrors;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setSubmitErrors([]);
              creditCard = {
                billingAddress: {
                  postalCode: postalCode
                },
                cvv: removeEmptySpaces(maybe(function () {
                  return formData.ccCsc;
                }, "") || ""),
                expirationDate: removeEmptySpaces(maybe(function () {
                  return formData.ccExp;
                }, "") || ""),
                number: removeEmptySpaces(maybe(function () {
                  return formData.ccNumber;
                }, "") || "")
              };
              _context2.next = 4;
              return tokenizeCcCard(creditCard);

            case 4:
              payment = _context2.sent;

              if (payment === null || payment === void 0 ? void 0 : payment.token) {
                processPayment(payment === null || payment === void 0 ? void 0 : payment.token, {
                  brand: payment === null || payment === void 0 ? void 0 : payment.ccType,
                  firstDigits: null,
                  lastDigits: payment === null || payment === void 0 ? void 0 : payment.lastDigits,
                  expMonth: null,
                  expYear: null
                });
              } else {
                braintreePayloadErrors = [{
                  message: "Payment submission error. Braintree gateway returned no token in payload."
                }];
                setSubmitErrors(braintreePayloadErrors);
                onError(braintreePayloadErrors);
              }

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleSubmit(_x2) {
      return _ref6.apply(this, arguments);
    };
  }();

  var allErrors = [].concat(_toConsumableArray(errors), _toConsumableArray(submitErrors));
  return React.createElement(S.Wrapper, {
    "data-test": "braintreePaymentGateway"
  }, React.createElement(CreditCardForm, {
    formRef: formRef,
    formId: formId,
    cardErrors: cardErrors.fieldErrors,
    labelsText: {
      ccCsc: "CVC",
      ccExp: "ExpiryDate",
      ccNumber: "Number"
    },
    disabled: false,
    handleSubmit: handleSubmit
  }), React.createElement(ErrorMessage, {
    errors: allErrors
  }));
};

export { BraintreePaymentGateway };